import { apiNl } from "@/utils/apiNl";
import { ChatBotRequest, ChatBotResponse } from "./ChatBotTypes";
import { message } from "antd";

export default class ChatBotRepository {
  async postChatbot(query: string, locationId: string): Promise<ChatBotResponse> {
    const payload: ChatBotRequest = { message: query, currentLocationId: locationId };
    const response = await apiNl.post(`/ai/chatbot`, payload);
    const data = response.data;
    return {
      messages: data.messages ?? [],
    };
  }
}
